export default __webpack_public_path__ + "static/media/mobile15.99b46aef.jfif";